import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from '../features/auth/LoginPage';
import DashboardPage from '../features/dashboard/DashboardPage';
import {
  LiveControlsPage,
  LiveLobbyPage,
  LivePlayerPage,
  LiveSessionWaitingPage,
} from '../features/liveSession';
import { LearnPage } from '../features/learn';
import {
  LineupsPage,
  StrategiesPage,
  StrategyDetailPage,
  StrategyEditorPage,
  StrategyStudioPage,
} from '../features/strategies';
import HomeRedirect from './HomeRedirect';
import RequireAuth from './RequireAuth';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/strategies"
        element={
          <RequireAuth>
            <StrategiesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/strategies/:strategyId"
        element={
          <RequireAuth>
            <StrategyDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/studio"
        element={
          <RequireAuth>
            <StrategyStudioPage />
          </RequireAuth>
        }
      />
      <Route
        path="/studio/:strategyId"
        element={
          <RequireAuth>
            <StrategyEditorPage />
          </RequireAuth>
        }
      />
      <Route
        path="/lineups"
        element={
          <RequireAuth>
            <LineupsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/learn"
        element={
          <RequireAuth>
            <LearnPage />
          </RequireAuth>
        }
      />
      <Route
        path="/live"
        element={
          <RequireAuth>
            <LiveLobbyPage />
          </RequireAuth>
        }
      />
      <Route
        path="/live/:teamId/sessions/:sessionId/matches/:matchId/controls"
        element={
          <RequireAuth>
            <LiveControlsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/live/:teamId/sessions/:sessionId/matches/:matchId"
        element={
          <RequireAuth>
            <LivePlayerPage />
          </RequireAuth>
        }
      />
      <Route
        path="/live/:teamId/sessions/:sessionId"
        element={
          <RequireAuth>
            <LiveSessionWaitingPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
